<template>
  <div class="background d-flex align-items-center pb-5">
    <b-container>
      <div class="pt-5">
        <!-- <h2 class="text-dark pt-5">Meet the experts</h2> -->
      </div>
      <b-row class="justify-content-center">
        <b-col cols="12" sm-10 offset-sm="1">
          <div class="mr-3 ml-3 mr-sm-5 ml-sm-5">
            <!--    <h1 class="text-color-dark">
              Explore the topics that are shaping the future of technology with
              our tracks! <br />
              <br />
              Enhance your experience in...
            </h1> -->
          </div>
        </b-col>
        <b-col sm="12" offset="">
          <div class="mr-3 ml-3 mr-sm-5 ml-sm-5">
            <Gallery
              class="gallery ml-1 mr-1 pr-xl-2 pl-xl-2 pr-md-3 pl-md-3"
            />
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>


<script>
import Gallery from "./Gallery.vue";

export default {
  components: {
    Gallery,
  },
};
</script>

<style scoped>
.background {
  background-color: rgba(222, 159, 194, 0.2);
  background-repeat: no-repeat;
  background-position: top center;
  background-size: cover;
  position: relative;
}
@media screen and (max-width: 1000px) {
  .background {
    height: 100%;
  }
}

.gallery {
  z-index: 999;
}
</style>


// WEBPACK FOOTER //
// src/components/MeetTheExperts.vue